import React, { useState } from 'react';

import { Alert, Box, Button, Grid, Stack } from '@mui/material';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import { TitlePages } from '@/components/Base/TitlePage';
import LineChartTermometro from '@/components/Base/LineChartTermometro';
import {
  useConsolidationSummaryTermometroStudentsDetail,
} from '@/features/termometro/getConsolidationSummaryTermometroStudentsDetail';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import { useHistoricoPedagogicoPorAluno } from '@/features/termometro/getHistoricoPedagogicoPorAluno';
import LineChartPedagogico from '@/components/Base/LineChartPedagogico';

const generateLastYears = (numYears) => {
  const currentYear = dayjs().year();
  return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
};

export const TermometroHistoricoPedagogico = ({ backRoute }) => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');

  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { id, name } = location.state || {};
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));


  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;

  const filters = {
    student_id: id,
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
    ...(daysDiff !== null && { days: daysDiff }),
  };

  const { data: summary, isError, refetch, isFetching } = useHistoricoPedagogicoPorAluno(filters);


  const handleClose = () => {
    setOpen(false);
  };

  const onApplyFilter = (selectedYear: number) => {
    setOpen(!!selectedYear);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)} />
          <TitlePages title={'Configurações avançadas/Termômetro pedagógico'} />
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        <Box marginTop={'10px'}>
          {/* <PeriodFilterDash
            startDate={selectedStartDate}
            endDate={selectedEndDate}
            onStartDateChange={setSelectedStartDate}
            onEndDateChange={setSelectedEndDate}
            refetchDashboard={() => console.log('teste')}
            listYears={listYears}
            setSelectedYear={setSelectedYear}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
          /> */}
        </Box>
        <LoadingChart loading={isFetching} />

        <Grid mt={'10px'} container spacing={2}>
          <Grid item xs={12}>
            {summary &&
              <LineChartPedagogico data={summary} lineColor={'#6F509680'} />
            }
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
